var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from '@emotion/styled';
import { alignItems, color, display, flexDirection, space, width, } from 'styled-system';
import { GridItem } from '../../common/components/Grid';
import { getCMSTrackerProps } from '../../common/tracking/getTrackerProps';
import { usePropOrTranslation } from './hooks';
import { NewsletterVoucher, CommonText, } from './NewsletterVoucher';
import { ResponsiveLazyImageMemo, } from '../../common/components/LazyImage';
var VoucherContainerGrid = styled(GridItem)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), display, flexDirection, alignItems, color);
VoucherContainerGrid.defaultProps = {
    w: [1, null, 7 / 12],
    display: 'flex',
    flexDirection: ['column', null, 'row'],
    alignItems: 'center',
};
var TextContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n  text-align: center;\n  line-height: 24px;\n  margin: 0 auto;\n"], ["\n  width: 100%;\n  text-align: center;\n  line-height: 24px;\n  margin: 0 auto;\n"])));
var Message = styled(CommonText)(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
Message.defaultProps = __assign(__assign({}, CommonText.defaultProps), { fontSize: ['fs_16', null, null, 'fs_18'], lineHeight: 3, fontWeight: 'normal' });
var Disclaimer = styled(CommonText)(templateObject_4 || (templateObject_4 = __makeTemplateObject([""], [""])));
Disclaimer.defaultProps = __assign(__assign({}, CommonText.defaultProps), { fontSize: ['fs_16', 'fs_14', null, 'fs_16'], fontWeight: 'normal' });
var Icon = styled(ResponsiveLazyImageMemo)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n\n  flex-shrink: 0;\n"], ["\n  ", ";\n  ", ";\n  ", ";\n\n  flex-shrink: 0;\n"])), display, width, space);
Icon.defaultProps = {
    display: ['none', null, 'flex'],
    width: [null, null, '144px', '192px'],
    mr: [null, null, 'sp_24', 'sp_32'],
};
var getSublineTrackingProps = function (subline) {
    return getCMSTrackerProps({
        dangerouslySetInnerHTML: { __html: subline },
    }, {
        event: 'footerTracking',
        eventData: {
            placement: 'newsletterSignup',
            labelIdentifier: 'h24_newsletter_message_link',
        },
    }, ['A']);
};
export var NewsletterContent = function (_a) {
    var voucher = _a.voucher, icon = _a.icon, textColor = _a.textColor, textProps = __rest(_a, ["voucher", "icon", "textColor"]);
    var _b = usePropOrTranslation(textProps), headline = _b.headline, subline = _b.subline, asteriskText = _b.asteriskText;
    return (React.createElement(VoucherContainerGrid, { color: textColor },
        icon ? React.createElement(Icon, __assign({}, icon)) : React.createElement(NewsletterVoucher, __assign({}, voucher)),
        React.createElement(TextContainer, null,
            React.createElement(CommonText, { dangerouslySetInnerHTML: { __html: headline } }),
            React.createElement(Message, __assign({}, getSublineTrackingProps(subline))),
            React.createElement(Disclaimer, { dangerouslySetInnerHTML: {
                    __html: asteriskText,
                } }))));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
